<template>
  <section class="section container pt-0">
    <payroll-datatable />
  </section>
</template>

<script>
import PayrollDatatable from "./payroll_datatable/Index.vue";
export default {
  name: "StaffPayroll",
  components: {
    PayrollDatatable,
  },
  data() {
    return {
      module_settings: {},
    };
  },
  methods: {
    create() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
